/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Documents/view.blocks to change it.
import Body from './Body/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Documents({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/Documents"
  
}) {
  return (<React.Fragment
>
<Body
  viewPath={`${viewPath}/Body`}
/>
{children}
</React.Fragment>)
}